import React from 'react';

import { Buffer } from 'buffer';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { Avatar, Button, Modal } from 'antd';
import { QRCodeSVG } from 'qrcode.react';

import { AimOutlined, QrcodeOutlined } from '@ant-design/icons';

import LocationsMap, { getLocationPosition } from '@src/components/LocationsMap';
import { Z_INDEX } from '@src/constants/zIndex';

import styles from './styles.module.less';

const ICONS = {
  GPS: <AimOutlined />,
  QR: <QrcodeOutlined />,
  NFC: <span style={{ fontSize: '8px' }}>NFC</span>,
  BEACON: <span style={{ fontSize: '8px' }}>BLE</span>,
};

const variants = {
  primary: styles.primary,
  light: styles.light,
};

const downloadQR = () => {
  const svg = document.getElementById('qrcode');
  const svgData = new XMLSerializer().serializeToString(svg);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  const img = new Image();
  img.onload = () => {
    canvas.width = img.width;
    canvas.height = img.height;
    ctx.drawImage(img, 0, 0);
    const pngFile = canvas.toDataURL('image/png');

    const downloadLink = document.createElement('a');
    downloadLink.download = 'qrcode';
    downloadLink.href = `${pngFile}`;
    downloadLink.click();
  };

  const base64Str = Buffer.from(svgData, 'utf8').toString('base64');
  img.src = `data:image/svg+xml;base64,${base64Str}`;
};

const AvatarLocation = ({ type, location, size = 24 }) => {
  const intl = useIntl();
  const locationType = location?.type?.toUpperCase();

  const qrModal = content => {
    Modal.info({
      okText: intl.formatMessage({ id: 'button.ok' }),
      maskClosable: true,
      icon: null,
      zIndex: Z_INDEX.MODAL_OVER_DRAWER,
      content: (
        <div>
          <QRCodeSVG
            id="qrcode"
            value={content?.token}
            size="100%"
            onClick={downloadQR}
            style={{ cursor: 'pointer' }}
          />
          <Button onClick={downloadQR} type="primary">
            {intl.formatMessage({ id: 'button.download' })}
          </Button>
        </div>
      ),
    });
  };

  const gpsModal = content => {
    const position = getLocationPosition(content);
    if (!position) {
      return;
    }

    const mapItem = {
      id: content?.id || 'gps-location',
      name: content?.name,
      position,
      distance: content?.distance,
    };

    Modal.info({
      okText: intl.formatMessage({ id: 'button.ok' }),
      maskClosable: true,
      icon: null,
      width: 640,
      zIndex: Z_INDEX.MODAL_OVER_DRAWER,
      title: content?.name,
      content: (
        <LocationsMap
          visible
          scrollWheelZoom={false}
          height="320px"
          items={[mapItem]}
          getPopupText={item => item?.name}
          popupTrigger="hover"
        />
      ),
    });
  };

  const handleAction = {
    GPS: gpsModal,
    QR: qrModal,
  };

  const handleClick = event => {
    event.stopPropagation();
    handleAction[locationType]?.(location);
  };

  const isClickable = Boolean(handleAction[locationType]);

  return (
    <Avatar
      onClick={isClickable ? handleClick : undefined}
      className={classNames(
        styles.locationAvatar,
        variants[type || 'primary'],
        !isClickable && styles.locationAvatarStatic,
      )}
      icon={ICONS[locationType]}
      size={size}
    />
  );
};

export default AvatarLocation;
